module.exports = __webpack_public_path__ + "img/2.e7c711a4.jpg";